import { apiClient } from './client';

// Period-end unrealized FX revaluation (Rule MC6).
export interface FxRevaluationItem {
  partyType: string;
  partyCode: string;
  documentType: string;
  currency: string;
  outstandingForeign: number;
  bookedBase: number;
  periodEndRate: number;
  revaluedBase: number;
  delta: number;
}

export interface FxRevaluationResult {
  executed: boolean;
  financialYearCode: string;
  periodCode: string;
  periodEndDate: string;
  baseCurrency: string;
  totalUnrealizedGain: number;
  totalUnrealizedLoss: number;
  netAdjustment: number;
  revaluationJournalNo?: string | null;
  reversalJournalNo?: string | null;
  reversalDate?: string | null;
  items: FxRevaluationItem[];
  warnings: string[];
}

export interface FxRevaluationRequest {
  financialYearCode: string;
  periodCode: string;
}

export const fxRevaluationApi = {
  async preview(req: FxRevaluationRequest): Promise<FxRevaluationResult> {
    const r = await apiClient.post('/finance/fx-revaluation/preview', req);
    return r.data?.data;
  },
  async run(req: FxRevaluationRequest): Promise<FxRevaluationResult> {
    const r = await apiClient.post('/finance/fx-revaluation/run', req);
    return r.data?.data;
  },
};
